<div class="basicrow tabtopb f-black roboto-r f-reg">
    <div class="basicr-line f-big padding-top1">
        Plan Actual
    </div>
    <div class="basicrow m-top-i">
        <div class="row">
            <div class="left">
                <div class="userinfo full nomtops">
                    <div class="basicrow">
                        <div class="basicrow f-bmed roboto-b m-bott">
                            Detalle del Plan
                        </div>
                        <div class="redstat">
                            <div class="autorow roboto-r pull-left">
                                Plan Actual
                            </div>
                            <div class="autorow roboto-b pull-right" style="line-height: 2;">
                                {{this.info[index].planInfoField.sOCDescriptionField}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right">
                <div class="autowcont cyclefact">
                    <div class="basicrow msidespad m-bott-i">
                        <div class="b-title">
                            <div class="autocont f-black roboto-m f-bmed pull-left vcenter">
                                <div class="tabcell">
                                    Ciclo de Facturaci&oacute;n
                                </div>
                            </div>
                        </div>
                        <div class="basicrow">
                                <div class="left-bill m-top-i">
                                    <div class="basicrow f-reg f-black roboto-r text-center">
                                        <span class="roboto-b">Ciclo de Facturaci&oacute;n</span><br/>
                                        <span class="roboto-b f-mgray">{{this.billingCycle}}</span>
                                    </div>

                                    <div class="basicrow text-center m-top-ii">
                                        <app-graphic-datapurchase [indexI]="this.index" ></app-graphic-datapurchase>
                                    </div>
                                </div>
                                <div class="right-bill">
                                    <div class="basicrow f-reg f-black roboto-r text-center vencimiento">
                                        <span class="roboto-b">Su Factura Vence</span><br/>
                                        <span class="roboto-b f-big">{{this.expiration}}</span>
                                    </div>
                                    <div class="basicrow m-top text-center">
                                        <a href="/usage" class="linkdefs">Ver Detalle&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="basicr-line f-big m-top-i">
        Planes de Datos Adicionales
    </div>
</div>